module.exports = __webpack_public_path__ + "static/img/login-logo.0cfac0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/configure/jingshi/login-logo.png
// module id = 1g8m
// module chunks = 23